import { Tag } from 'components/Tag';
import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';
import { useContext } from 'react';

export const ContentSidebarJobPreferencesAgeGroups = () => {
  const { userProfile, hasPreferences } = useContext(ContactSidebarContext);

  if (!hasPreferences.ageGroups) {
    return null;
  }

  const ageGroups = userProfile?.ageGroups();

  return (
    <div className="space-y-1.5">
      <p className="text-primary-pure-blue">Age Groups:</p>
      <div className="flex items-start justify-start flex-wrap gap-2">
        {ageGroups.map((group) => (
          <Tag key={group}>{group}</Tag>
        ))}
      </div>
    </div>
  );
};

ContentSidebarJobPreferencesAgeGroups.displayName = 'ContentSidebarJobPreferencesAgeGroups';
